const LEVEL_VALUES = {
  visibleRows: 5,
  cols: 7,
  tileSize: 120,
  rows: 10,
  scale: 1,
  scaleXs: 0.7,
};
const LEVELS = {
  level1: {
    nextLevel: 'level2',
    nextImage: 'transition-level1-2.jpg',
    bottomImage: 'bottom-level1.jpg',
    types: 5,
  },
  level2: {
    nextLevel: 'level3',
    nextImage: 'transition-level2-3.jpg',
    bottomImage: 'bottom-level2.jpg',
    types: 6,
  },
  level3: {
    nextLevel: 'level1',
    nextImage: 'transition-level3-1.jpg',
    bottomImage: 'bottom-level3.jpg',
    types: 14,
  },
};

const DELTA_WIDTH = 40;
const GAME_HEIGHT = LEVEL_VALUES.visibleRows * LEVEL_VALUES.tileSize;
const GAME_WIDTH = (LEVEL_VALUES.cols * LEVEL_VALUES.tileSize) - DELTA_WIDTH;
const SCALE_VALUE = 0.5;
const SCALE_VALUE_XS = 0.35;
const WINDOW_SCALING_WIDTH = (GAME_WIDTH * LEVEL_VALUES.scaleXs) - LEVEL_VALUES.tileSize;

export default {
  LEVEL_VALUES,
  DELTA_WIDTH,
  GAME_HEIGHT,
  GAME_WIDTH,
  LEVELS,
  SCALE_VALUE,
  SCALE_VALUE_XS,
  WINDOW_SCALING_WIDTH,
};



// WEBPACK FOOTER //
// ./src/js/gameConsts.js